import Vue from "vue";

export async function printSale(sale_id, payload) {
  const response = await Vue.prototype.$http.post(
    `sales/${sale_id}/print`,
    payload
  );

  return response.data;
}

export async function printDevolucao(devolucao_id, payload) {
  const response = await Vue.prototype.$http.post(
    `devolucoes/${devolucao_id}/print`,
    payload
  );

  return response.data;
}

export async function printClientHistory(client_id, payload) {
  const response = await Vue.prototype.$http.post(
    `clients/${client_id}/print`,
    payload
  );

  return response.data;
}

export async function printLocacao(locacao_id, payload) {
  const response = await Vue.prototype.$http.post(
    `locacoes/${locacao_id}/print`,
    payload
  );

  return response.data;
}
